var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4223 32.4557C24.0251 32.4557 23.6278 32.3094 23.3141 31.9957C22.7078 31.3894 22.7078 30.3857 23.3141 29.7794L27.5587 25.5348L23.3141 21.2903C22.7078 20.6839 22.7078 19.6803 23.3141 19.0739C23.9205 18.4675 24.9241 18.4675 25.5305 19.0739L30.8832 24.4266C31.4896 25.033 31.4896 26.0366 30.8832 26.643L25.5305 31.9957C25.2378 32.3094 24.8196 32.4557 24.4223 32.4557Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6296 27.1032H8.36506C7.50778 27.1032 6.79688 26.3923 6.79688 25.535C6.79688 24.6777 7.50778 23.9668 8.36506 23.9668H29.6296C30.4869 23.9668 31.1978 24.6777 31.1978 25.535C31.1978 26.3923 30.4869 27.1032 29.6296 27.1032Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0916 43.7052C24.2343 43.7052 23.5234 42.9943 23.5234 42.137C23.5234 41.2797 24.2343 40.5688 25.0916 40.5688C34.0198 40.5688 40.2507 34.3379 40.2507 25.4097C40.2507 16.4815 34.0198 10.2506 25.0916 10.2506C24.2343 10.2506 23.5234 9.53971 23.5234 8.68244C23.5234 7.82517 24.2343 7.11426 25.0916 7.11426C35.8598 7.11426 43.3871 14.6415 43.3871 25.4097C43.3871 36.1779 35.8598 43.7052 25.0916 43.7052Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.1cf4e12da0669b8bdf57ae2b4ead7d87.svg";
export { ForwardRef as ReactComponent };